const reds = {
  1: { main: '#E60012', font: '#000000' },
  2: { main: '#A00000', font: '#000000' },
};

export default reds;
